






































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
import {acceptedImageTypes, redirectTime} from '@/constants/constants';
import {extractDetailsFromBase64} from '@/services/api/image';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class CreateNews extends Vue {
  //Store Variables
  showSuccessToast: any;
  showErrorToast: any;
  acceptedImageTypes = acceptedImageTypes;

  //Form Variables
  newsHeading = '';
  newsDescription = '';
  newsStatus = false;
  imagebase64URL = '';
  imageName = '';

  //Validation Variables
  imageValidationMsg: any = null;
  headingValidationMsg: any = null;
  descValidationMsg: any = null;

  //Loader Variable
  loadingBtnStatus = false;

  //convert image into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imagebase64URL = base64url;
        this.imageValidationMsg = null;
      }
    } catch (error) {
      alert('Something went wrong with image');
    }
  }

  validateNewsHeading() {
    if (this.newsHeading === '' || this.newsHeading.trim().length < 1) {
      this.headingValidationMsg = 'This field is required.';
      return false;
    } else if (this.newsHeading.trim().length < 5) {
      this.headingValidationMsg = 'Minimum 5 characters required.';
      return false;
    } else {
      this.headingValidationMsg = null;
      return true;
    }
  }
  validateDescription() {
    if (this.newsDescription === '' || this.newsDescription.trim().length < 1) {
      this.descValidationMsg = 'This field is required.';
      return false;
    } else if (this.newsDescription.trim().length < 5) {
      this.descValidationMsg = 'Minimum 5 characters required.';
      return false;
    } else {
      this.descValidationMsg = null;
      return true;
    }
  }

  validateAll() {
    return this.validateNewsHeading() && this.validateDescription();
  }

  //submit button handler
  async _uploadHandler() {
    if (!this.validateAll()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      let {imageType, url} = extractDetailsFromBase64(this.imagebase64URL);
      const formData = {
        newsHeading: this.newsHeading,
        newsDescription: this.newsDescription,
        newsImageName: this.imageName,
        newsImage: url,
        imagetype: imageType,
        newsisactive: this.newsStatus,
      };

      let response = await API.createNews(formData);
      this.loadingBtnStatus = false;
      if (response.data) {
        let message: string = response.message;
        if (message.includes('created new news')) message = 'Record added successfully';
        this.showSuccessToast({msg: message});
        setTimeout(() => this._clickHanlder(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHanlder() {
    this.$router.go(-1);
  }
}
